import { IItemForGetShortInfoWithStatus, TCountOfItems, ISoftwareUpdates } from 'types';
import { TPushesViewSortBy, TTypeOfModalWindow } from './pushesViewState/pushesViewContext';
import { AxiosResponse } from 'axios';

export enum PushesViewActionTypes {
	SET_SOFTWARE_UPDATES = 'SET_SOFTWARE_UPDATES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_RESTAURANTS_FOR_PUSH = 'SET_RESTAURANTS_FOR_PUSH',
	SET_PUSH_CALLBACK = 'SET_PUSH_CALLBACK',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetSoftwareUpdates {
	type: PushesViewActionTypes.SET_SOFTWARE_UPDATES;
	payload: {
		softwareUpdates: ISoftwareUpdates;
	};
}

interface IChangeSearchString {
	type: PushesViewActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: string;
	};
}

interface ISetSortBy {
	type: PushesViewActionTypes.SET_SORT_BY;
	payload: {
		sortBy: TPushesViewSortBy;
	};
}

interface ISetCountOfItems {
	type: PushesViewActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: TCountOfItems;
	};
}

interface IChangeCurrentPage {
	type: PushesViewActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: number;
	};
}

interface ISetFetchedRestaurants {
	type: PushesViewActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IItemForGetShortInfoWithStatus[];
	};
}

interface ISetRestaurantsForPush {
	type: PushesViewActionTypes.SET_RESTAURANTS_FOR_PUSH;
	payload: {
		restaurantsForPush: string[];
	};
}

interface ISetPushCallback {
	type: PushesViewActionTypes.SET_PUSH_CALLBACK;
	payload: {
		pushCallback: ((restaurantsForPush: string[]) => Promise<void>) | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: PushesViewActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

export type TPushesViewAction =
	| ISetSoftwareUpdates
	| IChangeSearchString
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetFetchedRestaurants
	| ISetRestaurantsForPush
	| ISetPushCallback
	| IChangeTypeOfModalWindow;
